export const SKIP_WAITING_MESSAGE = Object.freeze({ type: 'SKIP_WAITING' })

export function requestServiceWorkerUpdate(waitingWorker) {
  if (!waitingWorker?.postMessage) {
    throw new Error('A waiting service worker is required to apply an update')
  }
  waitingWorker.postMessage(SKIP_WAITING_MESSAGE)
}

